<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Firstname') },
                { title: $t('Lastname') },
                { title: $t('PhoneNumber') },
                { title: $t('ProductName') },
                { title: $t('ItemCode') },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td>{{ row.firstName }}</td>
                <td style="width: 18%">
                  {{ row.lastName }}
                </td>
                <td style="width: 7%">
                  {{ row.phoneNumber }}
                </td>
                <td style="width: 15%">
                  {{ row.productName }}
                </td>
                <td style="width: 15%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 15%; direction: ltr">
                   {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
                </td>
                <td style="width: 20%">
                  <router-link :to="{ path: '/YaldaEvent/Details/' + row.id }">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="view-details"
                      >{{ $t("ViewDetails") }}</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}

.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "Content_Management_YaldaEvent_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "CMS/api/AdvertisingCampaignQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
